import * as Yup from "yup";
import checkout from "./form2";

const {
  formField2: {
    countryName,
    carrierName,
    year,
    supplementaryForThe,
    firstTime,
    vehicleName,
    taxPayerInstead,
    taxPayerInsteadId
  },
} = checkout;

const validation2 = Yup.object().shape({
  [vehicleName.name]: Yup.string().required(vehicleName.errorMsg),
  [countryName.name]: Yup.string().required(countryName.errorMsg),
  [carrierName.name]: Yup.string().required(carrierName.errorMsg),
  [year.name]: Yup.number().required(year.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [supplementaryForThe.name]: Yup.string()
  .matches(/^\d+$/, supplementaryForThe.invalidMsg)
  .required(supplementaryForThe.errorMsg),
  [taxPayerInstead.name]: Yup.string().required(taxPayerInstead.errorMsg),
  [taxPayerInsteadId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxPayerInsteadId.invalidMsg)
    .required(taxPayerInsteadId.errorMsg),

});

export default validation2;
